import React from 'react';
import styles from './loading.module.scss';
import Loader from '@components-clean/core/loader';

interface IProps {
    style?: React.CSSProperties | undefined;
}

const Loading = ({ style }: IProps) => (
    <div className={`loading-component ${styles.container}`} style={style}>
        <Loader />
    </div>
);

export default Loading;
